import React from 'react';
import {InputNumber} from 'primereact/inputnumber';
import AdminFieldLabel from './AdminFieldLabel';

interface AdminInputNumberProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  required?: boolean;
  name: string;
  id: string;
  className?: string;
  min?: number;
  max?: number;
  error?: string;
}

const AdminInputNumber: React.FC<AdminInputNumberProps> = ({
                                                             label,
                                                             value,
                                                             onChange,
                                                             placeholder,
                                                             required = false,
                                                             name,
                                                             id,
                                                             className = '',
                                                             min,
                                                             max,
                                                             error
                                                           }) => {
  const handleChange = (e: any) => {
    onChange(e.value);
  };

  return (
    <div className={className}>
      <AdminFieldLabel htmlFor={id} label={label} required={required}/>
      <InputNumber
        id={id}
        name={name}
        value={value}
        onValueChange={handleChange}
        placeholder={placeholder}
        min={min}
        max={max}
        showButtons
        className="w-full"
        inputClassName={`w-full px-4 py-3 border rounded-sm focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300 ${error ? 'border-red-500' : 'border-gray-300'}`}
      />
      {error && <small className="block text-red-500 text-xs mt-1">{error}</small>}
    </div>
  );
};

export default AdminInputNumber;

